import { Text } from '@chakra-ui/react';

const DisplayError = (msg: string): JSX.Element => {
  return (
    <Text mb={2} color="crimson" width="100%">
      {msg}
    </Text>
  );
};

export default DisplayError;
